import React from 'react';
import { useIsLoading } from '@tokenized/sdk-react-private';

function SessionRestoreSpinner({ children }) {
  const isLoading = useIsLoading();

  if (isLoading) {
    return (
      // The styles are in the head of app.html
      <div className="app-loader">
        <div className="circle-loader" />
      </div>
    );
  }
  return children;
}

export default SessionRestoreSpinner;
